import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    && {\n        flex: 1;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    && {\n        position: relative;\n        padding-bottom: 5px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ReactMarkdown from "react-markdown";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import { Link } from "react-router-dom";
import styled from "styled-components";

var webpackMarkdownLoader = require.context("!raw-loader!./", false, /\.md$/);

var StyledAppBar = styled(AppBar)(_templateObject());
var StyledTypography = styled(Typography)(_templateObject2());

var Transition = /*#__PURE__*/function (_React$Component) {
  _inherits(Transition, _React$Component);

  var _super = _createSuper(Transition);

  function Transition() {
    _classCallCheck(this, Transition);

    return _super.apply(this, arguments);
  }

  _createClass(Transition, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Slide, Object.assign({
        direction: "up"
      }, this.props));
    }
  }]);

  return Transition;
}(React.Component);

var EULADialogue = /*#__PURE__*/function (_React$Component2) {
  _inherits(EULADialogue, _React$Component2);

  var _super2 = _createSuper(EULADialogue);

  function EULADialogue(props) {
    var _this;

    _classCallCheck(this, EULADialogue);

    _this = _super2.call(this, props);

    _this.handleClickOpen = function () {
      _this.setState({
        open: true
      });
    };

    _this.handleClose = function () {
      _this.setState({
        open: false
      });
    };

    var EulaText = webpackMarkdownLoader.keys().map(function (filename) {
      return webpackMarkdownLoader("./EULA.md");
    });
    _this.state = {
      open: false,
      text: EulaText[0].default
    };
    return _this;
  }

  _createClass(EULADialogue, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Dialog, {
        fullScreen: true,
        open: this.props.open,
        onClose: this.props.handleClose,
        TransitionComponent: Transition
      }, /*#__PURE__*/React.createElement(StyledAppBar, null, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(StyledTypography, {
        color: "inherit"
      }, "EULA"))), /*#__PURE__*/React.createElement(DialogContent, {
        style: {
          paddingTop: "20px"
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subheading"
      }, "We license use of the App and Documents to you on the basis of this EULA and subject to any rules or policies applied by the Google Android application store from whose site, located at", " ", /*#__PURE__*/React.createElement(Link, {
        to: this.props.appUrl || ""
      }, this.props.appUrl), " ", "(Appstore), the End-user downloaded the App (Appstore Rules), or the APK send directly to you. We and/or the owners of the App and Documents remain the owners of the App and Documents at all times.", "\n\n"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ReactMarkdown, null, this.state.text)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.handleClose,
        color: "primary"
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.handleAgree,
        color: "primary"
      }, "Agree")));
    }
  }]);

  return EULADialogue;
}(React.Component);

export default EULADialogue;